import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2fb9a1e5&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&id=2fb9a1e5&lang=scss&scoped=true&"
import style2 from "./App.vue?vue&type=style&index=2&id=2fb9a1e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb9a1e5",
  null
  
)

export default component.exports